import { skipToken } from '@reduxjs/toolkit/query';
import Loader from 'components/Loader.tsx';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useGetMatterByIdQuery } from 'store/api/matters.ts';
import { RSQL_AND } from 'utils/filterUtil.ts';
import ExperienceRecordsTableReadOnly from '../../experience/ExperienceRecordsTableReadOnly.tsx';

interface Props {
    matterId?: string;
}

const ExperienceRecordsView: React.FC<Props> = ({ matterId }) => {
    const { data: matter, isLoading: isLoadingMatter } = useGetMatterByIdQuery(matterId ?? skipToken);

    if (!matterId) {
        return null;
    } else if (isLoadingMatter) {
        return <Loader />;
    }

    return (
        <div className="flex h-full flex-col gap-4">
            <h3 className="text-h3 text-fg-secondary">
                <FormattedMessage id="experience-records.experience-records" />
            </h3>
            {matter?.isExcludedFromXR ? (
                <div className="bg-grey-100 w-full rounded-[4px] p-6">
                    <h5 className="text-h5 text-fg-secondary text-center font-normal">
                        <FormattedMessage id="experience-records.matter-list-view.case-excluded" />
                    </h5>
                </div>
            ) : (
                <ExperienceRecordsTableReadOnly
                    createXrNavigationUrl={`/matter/${matterId}/experience-records/new`}
                    passiveFilter={`matterId==${matterId}${RSQL_AND}hasExperienceRecord==true`}
                    canRememberFilters={false}
                />
            )}
        </div>
    );
};

export default ExperienceRecordsView;
